<template>
  <div ref="background" class="background">
    <template v-if="loader.loaded && !loader.show">
      <v-container>
        <v-row>
          <v-col
            lg="3"
            md="4"
            sm="6"
            cols="12"
          >
            <v-card
              @click="showCreateScreenplayDialog()"
            >
              <v-card-text>
                <div
                  class="d-flex justify-center align-center"
                  style="height: 166px;"
                >
                  <span class="headline">建立劇本</span>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            lg="3"
            md="4"
            sm="6"
            cols="12"
            v-for="screenplay in screenplays"
            :key="screenplay.id"
          >
            <v-card
              @click="$router.push(`/edit?sid=${screenplay.id}&${actionMode ? 'actionMode=enable&' : ''}`)"
            >
              <v-card-text>
                <div
                  class="screenplay-name headline overflow-dot mb-1 ml-2"
                  :title="screenplay.name || screenplay.id"
                  v-text="screenplay.name || screenplay.id"
                >
                </div>
                <div class="screenplay-author subtitle-2 overflow-dot mb-2 ml-2">{{screenplay.authorName || 'empty'}}</div>
                <p class="screenplay-desc pa-2 pl mb-0">
                  {{screenplay.description}}
                </p>
              </v-card-text>
              <!-- <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="$router.push(`/screenplay/${screenplay.id}?${actionMode ? 'actionMode=enable&' : ''}`)">
                  DETAIL
                </v-btn>
              </v-card-actions> -->
            </v-card>
          </v-col>
          <v-col
            class="d-flex justify-center"
            cols="12"
          >
            <v-btn :to="prevPage" @click.prevent="changePage(currentPage - 1)" :disabled="!prevPage" style="margin-right: 2rem;">上一頁</v-btn>
            <v-btn :to="nextPage" @click.prevent="changePage(currentPage + 1)" :disabled="!nextPage">下一頁</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <!-- #Loader -->
    <transition name="fade">
      <v-dialog
        v-model="loader.show"
        hide-overlay
        :persistent="!loader.loaded"
        max-width="300"
      >
        <v-card
          color="secondary"
        >
          <v-card-text class="white--text" style="padding-top: 15px">
            <transition name="fade">
              <div v-if="!loader.loaded">
                <span v-text="loader.text"></span>
                <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
                ></v-progress-linear>
              </div>
            </transition>
          </v-card-text>
        </v-card>
      </v-dialog>
    </transition>
    <transition name="fade">
      <v-dialog v-model="createForm.show" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">建立劇本</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field v-model="createForm.datas.name" label="劇本標題*" required></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="createForm.datas.description"
                    label="劇本介紹"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
            <!-- <small>*indicates required field</small> -->
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" @click="dialog = false">{{$t('Close')}}</v-btn>
            <v-btn color="primary" @click="createFormSubmit()">{{$t('Create')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </transition>
  </div> <!-- .background -->
</template>

<script>
// import { VueTyper } from 'vue-typer'
import Screenplay from '@/lib/Screenplay'
import * as util from '@/lib/util'
import * as gameLoader from '@/lib/loader'
import homeDrawer from '@/lib/drawer/homeDrawer'

export default {
  name: 'screenplay-manage',
  components: {
  },
  computed: {
    user(){
      return this.$store.state.user.profile
    },
    actionMode(){
      return this.$store.state.actionMode
    },
    /**
     * google assistant的預留空間
     */
    assistantHeaderHeight(){
      return this.$store.state.assistantHeaderHeight
    },
    nextPage(){
      if(this.currentPage * this.countPerPage < this.screenplayTotal){
        return `/?p=${this.currentPage + 1}`
      }
      return null
    },
    prevPage(){
      if(this.currentPage > 1){
        return `/?p=${this.currentPage - 1}`
      }
      return null
    }
  },
  watch: {
  },
  data: ()=>{
    return {
      screenplays: [],
      // 資料庫有的數量
      screenplayTotal: 0,
      // 每頁的資料筆數 ( min:10, max:50 )
      countPerPage: 20,
      currentPage: 1,
      createForm: {
        show: false,
        datas: {
          name: '',
          description: ''
        }
      },
      loader: {
        text: 'Loading',
        show: true,
        loaded: false
      }
    }
  },
  mounted(){
    this.$store.commit('appbar/setupDrawer', {
      items: homeDrawer,
      autoDisplay: true,
      show: !this.$mobile
    })
    // 備註：上下頁切換時，因為只改 query 所以不會觸發 mounted
    let page = parseInt(this.$route.query.p)
    if(Number.isNaN(page)) page = 1
    this.changePage(page)
  },
  updated(){
  },
  beforeDestroy(){
  },
  methods: {
    async updateScreenplayTotalCount(){
      try{
        this.screenplayTotal = await gameLoader.getScreenplayCount({ self: true })
      }catch(e){
        console.warn('get screenplayTotal failed')
        this.screenplayTotal = -1
      }
      return this.screenplayTotal
    },
    async changePage(page){
      this.currentPage = page
      await this.updateScreenplayTotalCount()
      await this.updatePageContent(page)
    },
    updatePageContent(page = 0){
      this.loader.show = true
      return gameLoader.getScreenplays(page, this.countPerPage, { self: true })
        .then((list)=>{
          window.scrollTo(0, 0)
          this.screenplays = list.filter((item)=>!item.id.match(/\.js/)).map((item)=>new Screenplay(item))
          this.loader.show = false
          this.loader.loaded = true
        })
    },
    showCreateScreenplayDialog(){
      this.createForm.show = true
      this.createForm.datas = {
        name: '',
        description: ''
      }
    },
    async createFormSubmit(){
      let screenplay = Screenplay.generateDefaultScreenplay()
      let datas = this.createForm.datas
      screenplay.name = datas.name
      screenplay.description = datas.description
      screenplay.author = this.user
      gameLoader.saveScreenplay(screenplay, { create: true })
        .then(()=>{
          this.$toast.info('建立成功')
          this.screenplays.unshift(screenplay)
          this.createForm.show = false
        })
    }
  }
}
</script>
<style>
.main-content{
  background-color: #15202B;
}
.vue-typer .custom.char{
  color: white;
}
</style>
<style scoped>
  .h-100{
    height: 100%;
  }
  .background{
    height: 100%;
    width: 100%;
    overflow-y: auto;
    background-color: #15202B;
    color: white;
  }
  .overflow-dot{
    white-space : nowrap;
    text-overflow : ellipsis;
    overflow: hidden;
  }
  .v-card .screenplay-desc{
    height: 100px;
    overflow-y:scroll;
    background-color:rgba(0, 0, 0, 0.1)
  }
</style>
